// removed by extract-text-webpack-plugin
module.exports = {"take-action-share":"take-action-share___MQZuT center___2iqBf","take-action-label":"take-action-label___8rEVO","take-action-icons":"take-action-icons___252fK center___2iqBf"};